<div class="delete-popup-container">
	<div class="content">
		<img src="assets/images/new-set/delete-primary.svg" alt="">
		<div class="title-container">
			<h3>
				{{
				fromLabBokkingTest
				? ('CONFIRM_DELETE_POPUP.LBL_DEL_LAB_TEST_RECORD'| translate)
				: ('CONFIRM_DELETE_POPUP.LBL_DEL_RECORD' | translate)
				}}
			</h3>
			<p style="word-wrap: break-word; width: 347px;">{{fromLabBokkingTest ? ('CONFIRM_DELETE_POPUP.LBL_REMOVE_RECORD'| translate) : ('CONFIRM_DELETE_POPUP.LBL_MSG'| translate)}}
				{{this.modelRemove.moduleName}} - {{this.modelRemove.name}} ?</p>
		</div>
	</div>
	<div class="text-right">
		<button class="secondary-cta link" (click)="close()">{{'CONFIRM_DELETE_POPUP.LBL_CANCEL'| translate}}</button>
		<button class="primary-cta" (click)="delete()">{{'CONFIRM_DELETE_POPUP.LBL_DELETE'| translate}}</button>
	</div>
</div>